import { render } from "./Infoscreen.vue?vue&type=template&id=1c332725&scoped=true"
import script from "./Infoscreen.vue?vue&type=script&lang=js"
export * from "./Infoscreen.vue?vue&type=script&lang=js"

import "./Infoscreen.vue?vue&type=style&index=0&id=1c332725&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c332725"]])

export default __exports__